import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PlatformQueryService } from '@core/services/platform-query.service';
import { ContactState, getAllContacts } from '@features/contacts/store/contact.reducer';
import {Conversation} from '../../../store/collaboration.models';
import { Store } from '@ngrx/store';
import { Api } from '@shared/constants/common-field.constants';
import { PlatformQuery } from '@shared/models/platform-query/platform-query';
import { Subject, takeUntil } from 'rxjs';
import { FuseSplashScreenService } from '@barebone-fuse/@fuse/services/splash-screen.service';
import { GetAllSharedContactsAction } from '@features/contacts/store/contact.action';

@Component({
    standalone: false,
    selector: 'app-mentioned-activities',
  templateUrl: './mentioned-activities.component.html',
  styleUrl: './mentioned-activities.component.scss'
})
export class MentionedActivitiesComponent implements OnInit, OnDestroy {

  conversationId: string | null = null;
  messageId: string | null = null;
  allContacts: Array<any> = [];
  private unsubscribe$ = new Subject<void>();
  conversation: Conversation | null = null;

  constructor(
    private route: ActivatedRoute, 
    private platformQueryService: PlatformQueryService, 
    private fuseSplashScreenService: FuseSplashScreenService, 
    private contactStore: Store<ContactState>
  ) {}

  ngOnInit(): void {
    this.loadContacts();
    this.subscribeToRouteParams();
  }

  private loadContacts(): void {
    this.contactStore.dispatch(new GetAllSharedContactsAction());
    this.contactStore
      .select(getAllContacts)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(data => {
        this.allContacts = data?.raw || [];
      });
  }

  private subscribeToRouteParams(): void {
    this.route.queryParamMap.pipe(takeUntil(this.unsubscribe$)).subscribe(params => {
      this.conversationId = params.get('conversationId');
      this.messageId = params.get('messageId');
      if (this.conversationId) {
        this.fetchConversation();
      }
    });
  }

  private fetchConversation(): void {
    if (!this.conversationId) return;
    const query = new PlatformQuery();
    query.name = 'GetConversationQuery';
    query.api = Api.Collaboration;
    query.fieldValues['ConversationId'] = this.conversationId;

    this.fuseSplashScreenService.show();
    this.platformQueryService.executeQuery(query).pipe(takeUntil(this.unsubscribe$)).subscribe(
      response => {
        this.fuseSplashScreenService.hide();
        this.processConversationResponse(response);
      },
      () => this.fuseSplashScreenService.hide()
    );
  }
  private processConversationResponse(response: any): void {
    const conversationWithMessages = response?.fieldValues?.['ConversationWithMessages'];

    if (conversationWithMessages) {
      const { conversation, messages, messageCount } = conversationWithMessages;

      const updatedConversation: Conversation = {
        ...conversation,
        messages,
        messageCount
      };
      if (updatedConversation.initialMessage) {
        updatedConversation.initialMessage.isInitialMessage = true;
        updatedConversation.messages.unshift(updatedConversation.initialMessage);
        updatedConversation.initialMessage = null;
      }

      updatedConversation.messages.forEach(message => {
        if (message.id === this.messageId) {
          message.makeHighlighted = true;
        }
      });

      this.conversation = updatedConversation;
    }
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }


}
